import axios from 'axios'
import qs from 'qs'
let isQa = /^(test|qa)-/.test(location.hostname);
let axiosbaseURL = "//activity" + (isQa ? 'test' : '') + ".zlongame.com";
// let axiosbaseURL = 'http://10.0.8.93:8083'
const instance = axios.create({
  // 创建axios实例，在这里可以设置请求的默认配置  创建一个新的axios实例
  baseURL: axiosbaseURL,
  timeout: 10000 // 设置超时时间10s
})
// 文档统一设置post请求头。(post请求一般才需要设置)
instance.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded'

/** 添加请求拦截器 **/
instance.interceptors.request.use(
  config => {
    if (config.isToken) {
      config.headers.accessToken = localStorage.getItem('accessToken')
    }
    if (config.method === 'get') {
      // 添加时间戳参数，防止浏览器（IE）对get请求的缓存
      config.params = {
        ...config.params
        // t: new Date().getTime()
      }
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 统一封装get请求
export const get = (url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    instance({
      method: 'get',
      url,
      params,
      // headers: {
      //   accessToken: ''
      // },
      ...config
    })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        console.log('error-', error, error.response)
        reject(error.response.data.exception)
      })
  })
}

// 统一封装post请求
export const post = (url, data) => {
  data = qs.stringify(data)
  return new Promise((resolve, reject) => {
    instance({
      method: 'post',
      url,
      data,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(response => {
        if (response.data.status === 1) {
          // 协议正常
          if (response.data.data.success) {
            resolve(response)
          } else {
            console.log(data.data.code) // 业务具体错误码处理
          }
        } else {
          console.log(data.info) // 协议具体错误信息
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

// 统一封装put请求
export const put = (url, data, config = {}) => {
  return new Promise((resolve, reject) => {
    instance({
      method: 'put',
      url,
      data,
      headers: {
        accessToken: ''
      },
      ...config
    })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

let axiosbaseURL1
if (isQa) {
  axiosbaseURL1 = "//accounttest.zlongame.com:" + (location.href.indexOf('https') != -1 ? '9443' : '9080');//9080
} else {
  axiosbaseURL1 = "https://member.zlongame.com"
}
const instance1 = axios.create({
  baseURL: axiosbaseURL1,
  timeout: 30000,
})
instance1.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

  /** 添加请求拦截器 **/
instance1.interceptors.request.use(
  config => {
    if (config.isToken) {
      config.headers.accessToken = localStorage.getItem('accessToken')
    }
    if (config.method === 'get') {
      // 添加时间戳参数，防止浏览器（IE）对get请求的缓存
      config.params = {
        ...config.params
        // t: new Date().getTime()
      }
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)
// 统一封装get请求
export const get1 = (url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    instance1({
      method: 'get',
      url,
      params,
      headers: config
    })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}
//支付接口
let axiosbaseURL2 = "//pay"+ (location.href.indexOf('https') != -1 ? 's' : '') + (isQa ? 'test' : '') + ".zlongame.com"+ (location.href.indexOf('https') != -1 ? '' : ':8081');
const instance2 = axios.create({
  baseURL: axiosbaseURL2,
  timeout: 30000,
})
instance2.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

  /** 添加请求拦截器 **/
instance2.interceptors.request.use(
  config => {
    if (config.isToken) {
      config.headers.accessToken = localStorage.getItem('accessToken')
    }
    if (config.method === 'get') {
      // 添加时间戳参数，防止浏览器（IE）对get请求的缓存
      config.params = {
        ...config.params
        // t: new Date().getTime()
      }
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)
// 统一封装get请求
export const post2 = (url, params) => {
  return new Promise((resolve, reject) => {
    instance2({
      method: 'post',
      url,
      params
    })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}
